import React, { Component } from 'react';
import map from 'lodash/map';
import PrescreenAnswerRow from 'containers/Manage-Questionnaire/prescreen/PrescreenAnswerRow';
import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import PrescreenAddAnswerDrawer from 'containers/Manage-Questionnaire/prescreen/PrescreenAddAnswerDrawer';
import { Table, TableHeader } from 'components/styled-components';
import {
  TableRow,
  AnswerWrapper,
  BlueText,
} from 'containers/Manage-Questionnaire/styled-components';
class PrescreenAnswers extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, currentIndex: null };
  }
  openDrawer = () => this.setState({ isOpen: true });
  closeDrawer = () => this.setState({ isOpen: false });
  setIndex = currentIndex => this.setState({ currentIndex });

  render() {
    const { answers, searchQuery } = this.props;
    return (
      <React.Fragment>
        <Table>
          <tbody>
            <TableRow>
              <TableHeader>ID</TableHeader>
              <TableHeader>Answer</TableHeader>
              <TableHeader>Display Categories</TableHeader>
              {/* Empty for edit button */}
              <TableHeader />
              {/* Empty for archive button */}
              <TableHeader />
            </TableRow>
            {map(answers, (answer, i) => (
              <PrescreenAnswerRow
                key={`${i}-${answer.answerID}`}
                isLastAnswer={answers.length === 1}
                answer={answer}
                index={i}
                currentIndex={this.state.currentIndex}
                setIndex={this.setIndex}
                searchQuery={searchQuery}
                {...this.props}
              />
            ))}
            <TableRow>
              <th colSpan="5" style={{ borderRadius: '0 0 3px 3px' }}>
                <AnswerWrapper cursor="pointer" onClick={this.openDrawer}>
                  <BlueText>
                    <Icon icon={IconNames.ADD_TO_ARTIFACT} />
                    ADD ANSWER
                  </BlueText>
                </AnswerWrapper>
              </th>
            </TableRow>
          </tbody>
        </Table>
        <PrescreenAddAnswerDrawer
          isOpen={this.state.isOpen}
          closeDrawer={this.closeDrawer}
          {...this.props}
        />
      </React.Fragment>
    );
  }
}

export default PrescreenAnswers;
